
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { LayoutDashboard, Users, LogOut, ClipboardCheck } from 'lucide-react'
import { useAuth } from '@/context/auth-context'

const sidebarItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/counsellor/dashboard' },
    { icon: Users, label: 'My Leads', path: '/counsellor/dashboard?view=leads' },
    { icon: ClipboardCheck, label: 'Admission Tracker', path: '/counsellor/dashboard?view=admissions' },
]

export function CounsellorSidebar() {
    const location = useLocation()
    const navigate = useNavigate()
    const { logout } = useAuth()

    const handleLogout = () => {
        if (window.confirm('Are you sure you want to logout?')) {
            logout()
            navigate('/login')
        }
    }

    return (
        <aside className="fixed left-0 top-0 h-screen w-64 bg-slate-900 text-white z-40 flex flex-col transition-all duration-300">
            {/* Logo Area */}
            <div className="p-6 flex items-center gap-3 border-b border-slate-800">
                <div className="h-8 w-8 bg-gradient-to-tr from-blue-500 to-indigo-600 rounded-lg flex items-center justify-center font-bold text-white shadow-lg shadow-blue-500/20">
                    C
                </div>
                <span className="font-display font-bold text-lg tracking-tight">Counsellor</span>
            </div>

            {/* Navigation */}
            <nav className="flex-1 py-6 px-3 space-y-1 overflow-y-auto custom-scrollbar">
                {sidebarItems.map((item) => {
                    const Icon = item.icon
                    const isActive = location.pathname + location.search === item.path || (item.path === '/counsellor/dashboard' && location.search === '' && location.pathname === '/counsellor/dashboard')

                    return (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 group ${isActive
                                ? 'bg-blue-600 text-white shadow-md shadow-blue-900/20'
                                : 'text-slate-400 hover:text-white hover:bg-slate-800'
                                }`}
                        >
                            <Icon className={`h-5 w-5 transition-colors ${isActive ? 'text-white' : 'text-slate-500 group-hover:text-white'}`} />
                            {item.label}
                        </Link>
                    )
                })}
            </nav>

            {/* Footer Actions */}
            <div className="p-4 border-t border-slate-800">
                <button
                    onClick={handleLogout}
                    className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium text-slate-400 hover:text-red-400 hover:bg-red-400/10 transition-colors"
                >
                    <LogOut className="h-5 w-5" />
                    Logout
                </button>
            </div>
        </aside>
    )
}
